import styled from '@emotion/styled';
import { GridCol } from '@naf/grid';
import { breakpoints } from '@naf/theme';

export const Wrapper = styled.div`
  width: 100%;
`;

export const SearchWrapper = styled.div`
  @media (min-width: ${breakpoints.l}) {
    width: calc(75% + 12px);
  }
`;

export const StyledGridCol = styled(GridCol)`
  padding-right: 0;
`;

export const DropdownArea = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  strong {
    font-weight: bold;
  }

  button {
    margin-right: -16px;
  }
`;
